import { render, staticRenderFns } from "./DipartimentiUnitn.vue?vue&type=template&id=388a94ac&"
import script from "./DipartimentiUnitn.vue?vue&type=script&lang=ts&"
export * from "./DipartimentiUnitn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports